import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { MultiCodeBlock } from 'gatsby-theme-apollo-docs';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`In your app Gradle file, apply the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`com.apollographql.apollo`}</code>{` plugin:`}</p>
    <p>{`Using the `}<a parentName="p" {...{
        "href": "https://docs.gradle.org/current/userguide/plugins.html#sec:plugins_block"
      }}>{`plugins DSL`}</a>{`:`}</p>
    <MultiCodeBlock mdxType="MultiCodeBlock">
      <div {...{
        "className": "gatsby-highlight",
        "data-language": "kotlin"
      }}><pre parentName="div" {...{
          "style": {
            "counterReset": "linenumber NaN"
          },
          "className": "language-kotlin line-numbers"
        }}><code parentName="pre" {...{
            "className": "language-kotlin"
          }}>{`plugins `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
  `}<span parentName="code" {...{
              "className": "token comment"
            }}>{`// ...`}</span>{`
  `}<span parentName="code" {...{
              "className": "token function"
            }}>{`id`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string"
            }}>{`"com.apollographql.apollo"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`.`}</span><span parentName="code" {...{
              "className": "token function"
            }}>{`version`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string"
            }}>{`"x.y.z"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span></code><span parentName="pre" {...{
            "aria-hidden": "true",
            "className": "line-numbers-rows",
            "style": {
              "whiteSpace": "normal",
              "width": "auto",
              "left": "0"
            }
          }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
      <div {...{
        "className": "gatsby-highlight",
        "data-language": "groovy"
      }}><pre parentName="div" {...{
          "style": {
            "counterReset": "linenumber NaN"
          },
          "className": "language-groovy line-numbers"
        }}><code parentName="pre" {...{
            "className": "language-groovy"
          }}>{`plugins `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
  `}<span parentName="code" {...{
              "className": "token comment"
            }}>{`// ...`}</span>{`
  `}<span parentName="code" {...{
              "className": "token function"
            }}>{`id`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string gstring"
            }}>{`"com.apollographql.apollo"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`.`}</span><span parentName="code" {...{
              "className": "token function"
            }}>{`version`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string gstring"
            }}>{`"x.y.z"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span></code><span parentName="pre" {...{
            "aria-hidden": "true",
            "className": "line-numbers-rows",
            "style": {
              "whiteSpace": "normal",
              "width": "auto",
              "left": "0"
            }
          }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    </MultiCodeBlock>
    <p>{`Or using the `}<a parentName="p" {...{
        "href": "https://docs.gradle.org/current/userguide/plugins.html#sec:old_plugin_application"
      }}>{`legacy syntax`}</a>{`:`}</p>
    <MultiCodeBlock mdxType="MultiCodeBlock">
      <div {...{
        "className": "gatsby-highlight",
        "data-language": "kotlin"
      }}><pre parentName="div" {...{
          "style": {
            "counterReset": "linenumber NaN"
          },
          "className": "language-kotlin line-numbers"
        }}><code parentName="pre" {...{
            "className": "language-kotlin"
          }}>{`buildscript `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
  `}<span parentName="code" {...{
              "className": "token comment"
            }}>{`// ...`}</span>{`
  `}<span parentName="code" {...{
              "className": "token function"
            }}>{`classpath`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string"
            }}>{`"com.apollographql.apollo:apollo-gradle-plugin:x.y.z"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`

`}<span parentName="code" {...{
              "className": "token function"
            }}>{`apply`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span>{`plugin `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`=`}</span>{` `}<span parentName="code" {...{
              "className": "token string"
            }}>{`"com.apollographql.apollo"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span></code><span parentName="pre" {...{
            "aria-hidden": "true",
            "className": "line-numbers-rows",
            "style": {
              "whiteSpace": "normal",
              "width": "auto",
              "left": "0"
            }
          }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
      <div {...{
        "className": "gatsby-highlight",
        "data-language": "groovy"
      }}><pre parentName="div" {...{
          "style": {
            "counterReset": "linenumber NaN"
          },
          "className": "language-groovy line-numbers"
        }}><code parentName="pre" {...{
            "className": "language-groovy"
          }}>{`buildscript `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
  `}<span parentName="code" {...{
              "className": "token comment"
            }}>{`// ...`}</span>{`
  `}<span parentName="code" {...{
              "className": "token function"
            }}>{`classpath`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token string gstring"
            }}>{`"com.apollographql.apollo:apollo-gradle-plugin:x.y.z"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`

apply plugin`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`:`}</span>{` `}<span parentName="code" {...{
              "className": "token string gstring"
            }}>{`"com.apollographql.apollo"`}</span></code><span parentName="pre" {...{
            "aria-hidden": "true",
            "className": "line-numbers-rows",
            "style": {
              "whiteSpace": "normal",
              "width": "auto",
              "left": "0"
            }
          }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    </MultiCodeBlock>
    <p>{`The plugin is hosted on the Gradle plugin portal, Jcenter and Maven Central.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      